<template>
  <div id="large-container" class="d-none d-xl-flex flex-column h-100 pl-2 pr-5 container float-left">
    <div class="spacer-top"></div>
    <div id="main" class="d-flex flex-column flex-grow-1 align-items-start justify-content-between">
      <ul class="mb-5">
        <li v-for="link in links" v-if="shouldDisplay(link)" :key="link.index" class="mb-3">
          <router-link
            :to="link.route"
            class="text-decoration-none"
            v-if="allowClick(link)"
          >
            <b-icon :icon="link.icon" class="icon text-white mr-1"></b-icon>
            <span
              class="pl-0 link"
              :class="{ 'link-active': isActive(link.route) }">
              {{ link.display }}
            </span>
          </router-link>
          <div v-else class="pointer">
            <b-icon :icon="link.icon" class="icon text-white mr-1"></b-icon>
            <span
              class="pl-0 link"
              :class="{ 'link-active': isActive(link.route) }">
              {{ link.display }}
            </span>
          </div>
        </li>
      </ul>
        <button @click="doLogout">
          <b-icon icon="door-open" class="icon text-white mr-1"></b-icon>
          <span class="pl-0 link">Logout</span>
        </button>
    </div>
    <div class="spacer-bottom"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SidebarContainer',
  props: ['links', 'isAdmin'],
  data() {
    return {
      title: 'Sidebar'
    }
  },
  methods: {
    ...mapActions(['doLogout']),
    isActive(route) {
      return `/${this.$route.path.split('/')[1]}` === route
    },
    shouldDisplay: function (link) {
      switch (link.access) {
        case 'all':
          return true
        case 'admin':
          return this.isAdmin
        case 'client':
          return !this.isAdmin
        default:
          return true
      }
    },
    allowClick: function (link) {
      return this.$route.path !== link.route
    }
  }
}
</script>

<style scoped>
#large-container {
  width: 200px;
  background-color: #2D3363;
}

.spacer-top {
  width: 100%;
  height: 80px;
}

.spacer-bottom {
  width: 100%;
  height: 40px;
}

#main {
  height: calc(100% - 70px);
}

ul {
  list-style-type: none;
}

.link {
  color: white;
  text-decoration: none;
}

.link-active {
  text-decoration: underline !important;
}

.link:hover {
  text-decoration: underline !important;
}

button {
  color: white;
}

.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/app/components/Layout/Sidebar/LargeSidebar.vue?6478e3aa